import { useEffect } from 'react';

import { useAuth as useOidcAuth } from 'react-oidc-context';

export default function useSilentRenew() {
  const { signinSilent, user } = useOidcAuth();

  const expiresAt = user?.expires_at;

  useEffect(() => {
    if (!expiresAt) return;

    const timeLeft = expiresAt * 1000 - Date.now() - 60_000;

    const timer = setTimeout(() => signinSilent(), timeLeft);

    return () => clearTimeout(timer);
  }, [signinSilent, expiresAt]);
}
